import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import person1 from "assets/img/person1.jpg";
import person2 from "assets/img/person2.jpg";
import person3 from "assets/img/person3.png";
import close from "assets/img/close.png";
import casestudy1 from "assets/img/casestudy1.png";
import casestudy2 from "assets/img/casestudy2.png";
import casestudy3 from "assets/img/casestudy3.png";

const Slider2 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1100,
    arrows: true, // Enable arrows
    spaceBetween: 20, // Space between slides
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  return (
    <section>
      <div className="relative figtree">
        <Slider {...settings}>
          <div className="xl:ml-52 lg:ml-32 md:ml-8 lg:mt-8 xl:mt-12 md:mt-12">
            <div
              className="bg-white"
              style={{
                height: "600px",
                width: "600px",
                borderRadius: "9999px",
              }}
            >
              <div className="flex justify-between">
                <div>
                  <div>
                    <img
                      className=""
                      src={casestudy1}
                      alt=""
                      style={{
                        width: "200px",
                        height: "200px",
                        borderRadius: "9999px",
                        border: "10px solid #fff",
                      }}
                    />
                  </div>
                </div>

                <div>
                  <div className="xl:-ml-28 lg:-ml-28 md:-ml-28 z-50">
                    <img
                      className="xl:w-12/12 lg:w-12/12 md:w-12/12"
                      src={close}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <p className="text-center text-black  xl:text-2xl  text-xl font-bold">
                Easy Handling for<br></br> Turmeric Production
              </p>
              <p className="xl:text-base lg:text-xl text-para text-center xl:pt-4 xl:px-8 lg:pt-4 lg:px-8 pt-4 px-8">
                Installing an aero-mechanical conveyor system to increase
                production and and take care of hygiene and maintenance for a
                dust-prone product like turmeric powder.
              </p>
              <h1 className="text-center xl:text-lg text-black xl:pt-4">
                Principal: Floveyor
              </h1>
              <div className="flex justify-center mb-8">
                <button className="borderblue xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-blue font-semibold xl:text-lg  xl:mt-6 rounded-md">
                  Read ›
                </button>
              </div>
            </div>
          </div>

          <div className="xl:ml-52 lg:ml-32 md:ml-8 lg:mt-8 xl:mt-12 md:mt-12">
            <div
              className="bg-white"
              style={{
                height: "600px",
                width: "600px",
                borderRadius: "9999px",
              }}
            >
              <div className="flex justify-between">
                <div>
                  <div>
                    <img
                      className=""
                      src={casestudy2}
                      alt=""
                      style={{
                        width: "200px",
                        height: "200px",
                        borderRadius: "9999px",
                        border: "10px solid #fff",
                      }}
                    />
                  </div>
                </div>

                <div>
                  <div className="xl:-ml-28 lg:-ml-28 md:-ml-28 z-50">
                    <img
                      className="xl:w-12/12 lg:w-12/12 md:w-12/12"
                      src={close}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <p className="text-center text-black  xl:text-2xl  text-xl font-bold">
                Lab-friendly Solution for<br></br> Nutraceutical Mixing
              </p>
              <p className="xl:text-base lg:text-xl text-para text-center xl:pt-4 xl:px-8 lg:pt-4 lg:px-8 pt-4 px-8">
                A major international pharma company required dry powder mixing
                of nutraceuticals. The solution had to meet laboratory standards
                of hygiene and dust-free conditions. They also required the
                mixer to be sealed to avoid contact with moisture as much as
                possible. The solution was compact, easily-movable in a lab and
                provided quick blends.
              </p>
              <h1 className="text-center xl:text-lg text-black xl:pt-4">
                Principal: Lindor
              </h1>
              <div className="flex justify-center mb-8">
                <button className="borderblue xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-blue font-semibold xl:text-lg  xl:mt-6 rounded-md">
                  Read ›
                </button>
              </div>
            </div>
          </div>

          <div className="xl:ml-52 lg:ml-32 md:ml-8 lg:mt-8 xl:mt-12 md:mt-12">
            <div
              className="bg-white"
              style={{
                height: "600px",
                width: "600px",
                borderRadius: "9999px",
              }}
            >
              <div className="flex justify-between">
                <div>
                  <div>
                    <img
                      className=""
                      src={casestudy3}
                      alt=""
                      style={{
                        width: "200px",
                        height: "200px",
                        borderRadius: "9999px",
                        border: "10px solid #fff",
                      }}
                    />
                  </div>
                </div>

                <div>
                  <div className="xl:-ml-28 lg:-ml-28 md:-ml-28 z-50">
                    <img
                      className="xl:w-12/12 lg:w-12/12 md:w-12/12"
                      src={close}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <p className="text-center text-black  xl:text-2xl  text-xl font-bold">
                Compact Potato Flakes<br></br> Production Line
              </p>
              <p className="xl:text-base lg:text-xl text-para text-center xl:pt-4 xl:px-8 lg:pt-4 lg:px-8 pt-4 px-8">
                Setting up a fully equipped potato flakes production line for a
                major Indian snacks manufacturer, in a limited space. With our
                engineering capabilities, we managed to fit the production line
                into a 20% lesser space than usually required
              </p>
              <h1 className="text-center xl:text-lg text-black xl:pt-4">
                Principal: Tummers
              </h1>
              <div className="flex justify-center mb-8">
                <button className="borderblue xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-blue font-semibold xl:text-lg  xl:mt-6 rounded-md">
                  Read ›
                </button>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow-next text-green bgarrows h-8 w-8 rounded-md absolute top-1/2 right-0 transform -translate-y-1/2 xl:mr-32 lg:mr-16 md:mr-4"
      onClick={onClick}
    >
      ❯ {/* Right arrow */}
    </button>
  );
};

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow-prev text-green bgarrows h-8 w-8 rounded-md absolute left-2 top-1/2 transform -translate-y-1/2 z-50  shadow-md xl:ml-0 lg:ml-0 md:-ml-8"
      onClick={onClick}
    >
      ❮ {/* Left arrow */}
    </button>
  );
};

export default Slider2;
